import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getProducts } from '../api';
import { authenticationQueryKeys } from '../data';
import { setSubscriptionProducts, useSubscriptionProducts } from '../store';
import { subscriptionProductsTransformer } from '../util/products-transformation';

export const useGetResources = () => {
  const products = useSubscriptionProducts();

  const resourcesQuery = useQuery({
    queryKey: [...authenticationQueryKeys.getSubcriptionProducts],
    queryFn: getProducts,
    staleTime: 5_000,
  });

  useEffect(() => {
    if (
      resourcesQuery.isError ||
      resourcesQuery.isFetched === false ||
      resourcesQuery.data === undefined
    )
      return;

    setSubscriptionProducts(
      subscriptionProductsTransformer(products, resourcesQuery.data),
    );
  }, [resourcesQuery.data, resourcesQuery.isError, resourcesQuery.isFetched]);

  return resourcesQuery;
};
